<template>
  <b-modal ref="modal" size="xl" lazy no-close-on-backdrop no-close-on-esc hide-header-close :hide-header="true"
    :title="getTitle()">
    <template v-slot:modal-title>
      <h4>{{ getTitle() }}</h4>
      <button @click="onClose" type="button" aria-label="Close" class="close">×</button>
      <hr>
    </template>

    <LoadingSpinner v-if="isLoading" />
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <b-btn @click="verifyAddress" size="sm" class="btn-light-blue-outline mr-2">
          <img class="verifyImg" src="/images/icons/verify-address-blue.png">
          Verify Address
        </b-btn>
        <b-btn class="btn-blue" size="sm" @click="submitOrigin">
          <span v-if="id">Update and Close</span>
          <span v-else>Submit</span>
        </b-btn>
      </div>
    </div>

    <div class="origin-modal">
      <p><i>Suggestion: This will appear on the shipping label, if a Company, you may want to leave First Name and Last
          Name blank</i></p>

      <b-form-row>
        <a class="ml-2 mb-2" v-if="!showLongAdress" href="javascript:void(0)" @click="onShowLongAddress">
          <img width="23" src="/images/icons/paste-button.png" style="margin-top: -3px;">
          Click here to paste address
        </a>
        <b-col sm="12" class="mb-2" v-if="showLongAdress">
          <b-form-group>
            <b-form-textarea v-model="long_address" placeholder="Name
Company (Optional)
Address Line 1
Address Line 2 (Optional)
City State Postal Code" rows="5" @change="onLongAddressChange"></b-form-textarea>
          </b-form-group>
        </b-col>

        <b-col sm="12"></b-col>

        <b-col sm="6" class="mb-2">
          <b-input id="first_name" name="first_name" type="text" size="sm" v-model="origin.first_name"
            placeholder="First Name"></b-input>
        </b-col>

        <b-col sm="6" class="mb-2">
          <b-input id="last_name" name="last_name" type="text" size="sm" v-model="origin.last_name"
            placeholder="Last Name"></b-input>
        </b-col>

        <b-col sm="12" class="mb-2">
          <b-input id="company" name="company" type="text" size="sm" v-model="origin.company" placeholder="Company">
          </b-input>
        </b-col>

        <b-col sm="12" class="mb-2">
          <GoogleAutoComplete :g-class="['form-control', 'form-control-sm']" v-model="origin.address"
            placeholder="Address" @change="onGoogleAddressChange"></GoogleAutoComplete>
        </b-col>

        <b-col sm="6" class="mb-2">
          <zip-code-input id="postal" type="text" size="sm" class="form-control form-control-sm" v-model="origin.postal"
            placeholder="Postal Code"></zip-code-input>
        </b-col>

        <b-col sm="6" class="mb-2">
          <b-input id="city" name="city" type="text" size="sm" v-model="origin.city" placeholder="City"></b-input>
        </b-col>

        <b-col sm="6" class="mb-2">
          <b-select id="state" type="text" size="sm" v-model="origin.state" :options="stateSelectOptions"
            placeholder="State"></b-select>
        </b-col>

        <b-col sm="6" class="mb-2">
          <b-input value="US" size="sm" disabled></b-input>
        </b-col>

        <b-col sm="12" class="mb-2">
          <b-input name="phone" type="tel" size="sm" v-model="origin.phone" v-mask="'(###) ###-####'"
            placeholder="Phone Number"></b-input>
        </b-col>

        <b-col sm="12" class="mb-2">
          <zip-code-input id="postal-origin" type="text" class="form-control form-control-sm"
            v-model="origin.postal_origin"
            placeholder="Postal Code where the packages will be processed (may differ from address above)">
          </zip-code-input>
        </b-col>
      </b-form-row>
    </div>
  </b-modal>
</template>

<style lang="scss" scoped>
fieldset.form-group {
  margin-bottom: 0;
}

textarea {
  font-size: .875rem !important;
  resize: none !important;
}
</style>

<script>
import GoogleAutoComplete from "../../components/GoogleAutoComplete";
import LoadingSpinner from "../../components/LoadingSpinner";

import states from "../../data/states";
import formatters from "../../formatters";

import human from 'parse-full-name';
import parser from 'parse-address';

export default {
  components: {
    LoadingSpinner,
  },
  mixins: [
    GoogleAutoComplete
  ],
  data() {
    return {
      showLongAdress: false,
      isLoading: false,
      long_address: '',
      id: null,
      origin: {},
    }
  },
  computed: {
    stateSelectOptions() {
      return [
        { value: null, text: 'State' },
        ...states.getSelectOptions()
      ]
    }
  },
  mounted() { },
  methods: {
    getTitle() {
      if (this.id) return 'Edit Origin Address'
      return 'Create Origin Address'
    },
    onShowModal(id = null) {
      this.showLongAdress = false;
      this.id = id
      this.origin = {
        id: null,
        first_name: null,
        last_name: null,
        company: null,
        address: null,
        city: null,
        state: null,
        postal: null,
        postal_origin: null,
        country: null,
        phone: null,
        actions: null,
      }
      if (id) {
        const origin = this.$parent.getOriginById(id)
        this.origin = origin
      }
      this.$refs.modal.show();
    },
    async submitOrigin() {
      this.long_address = ''
      this.isLoading = false;
      this.showLongAdress = false;

      const tzUrl = `${process.env.MIX_INTEG_URL}/get-tz?zipcode=${this.origin.postal}`;
      const tz = await axios.get(tzUrl);
      const originData = Object.assign({}, this.origin, { timezone: tz.data || "America/New_York" })

      if (![5, 10].includes(this.origin.postal.length)) {
        this.$parent.$emit("alert", {
          message: "Postal code is not valid, please double check.",
          type: "danger"
        });
        return;
      }

      if (this.origin.postal_origin && ![5, 10].includes(this.origin.postal_origin.length)) {
        this.$parent.$emit("alert", {
          message: "Origin postal code is not valid, please double check.",
          type: "danger"
        });
        return;
      }

      if (!this.origin.phone) {
        this.$parent.$emit("alert", {
          message: "Phone number is a required field.  Please enter and resubmit.",
          type: "danger"
        });
        return;
      }
      if (this.id) {
        const url = "/origin/" + this.id
        await this.submitForm(originData, url, "patch")
      } else {
        await this.submitForm(originData)
      }
      this.$refs.modal.hide();
    },
    async submitForm(data, url = "/origin", method = "post") {
      try {
        const response = await axios({
          method: method,
          url: url,
          data: data
        });
        this.$parent.$emit("alert", {
          message: response.data.message,
          type: "success"
        });
      } catch (error) {
        this.$parent.$emit("alert", {
          message: error.response.data.message,
          type: "danger"
        });
      } finally {
        this.$parent.fetchInfo();
        this.$parent.refreshUser();
      };
    },
    onGoogleAddressChange(addr) {
      if (addr.country !== 'US') {
        this.$parent.$emit('alert', {
          type: 'danger',
          message: 'Only addresses from US is allowed.'
        })
      } else {
        addr.postal = addr.postal_code
        addr.postal_origin = addr.postal_code
        addr.state = addr.state || addr.province
        this.origin = Object.assign({}, this.origin, addr);
      }
    },
    onLongAddressChange(val) {
      if (val) {
        this.parseAddress(val);
      } else {
        this.onClearItems();
      }
    },
    onClearItems() {
      this.origin = {
        company: '',
        first_name: '',
        last_name: '',
        state: null,
        province: '',
        city: '',
        address: '',
        address2: '',
        postal: '',
        postal_origin: '',
        country: 'US',
      }
      this.long_address = ''
    },
    onClose() {
      this.onClearItems();
      this.$refs.modal.hide();
    },
    async parseAddress(long_address) {
      let address = long_address.split(/\r?\n/).map(a => a.trim()).filter(a => a.length > 0);

      if (address.length === 1) {
        address = long_address.split(/,/).map(a => a.trim()).filter(a => a.length > 0);
        this.long_address = address.join('\r\n');
      }

      if (address.length > 2) {
        this.isLoading = true;
        // check if country is on the last element then remove
        if (['us', 'usa', 'america', 'united states', 'united states of america'].includes(address[address.length - 1].trim().toLowerCase())) {
          address.pop();
        }

        // parse name (Expecting that the first row is name)
        let first = address.shift();
        let parsedName = human.parseFullName(first);

        // if address doesn't have number, move it to company
        let second = address[0];
        let company = '';

        const re = /\d/;
        if (!re.test(second)) {
          company = second;
          address.shift();
        }

        // address parser
        const parsedAddress = parser.parseLocation(address.join(' '));
        const postal_code = parsedAddress.plus4 ? `${parsedAddress.zip}-${parsedAddress.plus4}` : parsedAddress.zip

        if (!postal_code) {
          this.isLoading = false;
          this.$parent.$emit('alert', {
            message: 'Postal code is required.',
            type: 'danger'
          });
        } else {
          // get city state from ziptastic api
          const city_state = await this.getCityState(postal_code);

          let data = {
            company: company,
            first_name: parsedName.first,
            last_name: parsedName.last,
            state: city_state.state,  // new shipment uses province
            province: city_state.province,
            city: city_state.city,
            address: address[0],
            address2: address.length > 2 ? address[1] : '',
            postal: postal_code,
            postal_origin: postal_code,
            country: 'US',
          }

          this.origin = Object.assign({}, this.origin, data)
        }
      }
    },
    async getCityState(zip) {
      this.isLoading = true;

      let url = "https://zip.getziptastic.com/v2/US/" + zip;
      var axiosCrossDomain = axios;
      delete axiosCrossDomain.defaults.headers.common["X-CSRF-TOKEN"];
      delete axiosCrossDomain.defaults.headers.common["X-Requested-With"];

      try {
        let { data: { state_short, city, country } } = await axiosCrossDomain(url, { method: "GET" })
        const pattern = /^(APO|FPO|DPO)\s(AE|AA|AP)$/

        if (pattern.test(city.toUpperCase())) {
          const [c, s] = city.split(" ");
          state_short = s;
          city = c;
        }

        this.origin.city = city;
        this.origin.province = state_short;
        this.origin.state = state_short;
        // this.origin.country = country;

        return {
          city: city,
          province: state_short,
          state: state_short,
        }
      } catch (error) {
        console.log('City State Error: ', error);
      } finally {
        this.isLoading = false;
      }
    },
    onShowLongAddress() {
      this.showLongAdress = true;
    },
    verifyAddress() {
      let address = formatters.address.toPb(this.origin);
      this.isLoading = true;
      axios
        .post("/verify", { address: address })
        .then(response => {
          this.isLoading = false;

          this.$parent.$emit("alert", {
            message: this.$t("alerts.address.valid"),
            type: "success"
          });

          let address = response.data;

          if (
            address &&
            (address.status === "VALIDATED_CHANGED" ||
              address.status === "VALIDATED_AND_NOT_CHANGED")
          ) {
            // Mass-assign to not delete name
            address = formatters.address.fromPb(address);
            this.origin = Object.assign({}, this.origin, address);
          }
        })
        .catch(e => {
          this.isLoading = false;
          this.$parent.$emit("alert", {
            message:
              address.countryCode === "US"
                ? "Address could not be verified. Please double check address to avoid delay or undeliverable. You may still proceed to print label."
                : "Sorry, address verification is only for U.S. addresses",
            type: "danger"
          });
        });
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/MyAccount/OriginModal.vue